import styled from '@emotion/styled';
import { TagInfo, TextCaption } from '@ferreri/prever-component-lib';
import { convertToBrazilianReal } from '../../../utils/convertToBrazilianReal';

type DependentInfoItemProps = {
  label: string;
  showAbsolute: boolean;
  showRelative: boolean;
  relative_price?: number;
  absolute_price?: number;
};

export const DependentInfoItem = (props: DependentInfoItemProps) => (
  <LineWrapper>
    <TextCaption>{props.label}</TextCaption>
    {!props.showAbsolute && !props.showRelative ? (
      <TagInfo>incluso no valor</TagInfo>
    ) : (
      <TagInfo>
        {props.showRelative && `+${props.relative_price}%`}
        {props.showRelative && props.showAbsolute && ' '}
        {props.showAbsolute &&
          `+${convertToBrazilianReal(props.absolute_price)}`}
      </TagInfo>
    )}
  </LineWrapper>
);

const LineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
